import React from 'react';
import './App.css';
import Container from '@mui/material/Container';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Footer from "./components/Footer";
import Home from "./pages/Home"
import Contact from "./pages/Contact"
import About from "./pages/About"
import Links from "./pages/Links";
import Training from "./pages/Training";
import Services from "./pages/Services";
import Membership from "./pages/Membership";
import Consignment from "./pages/Consignment";
import CookiePopup from "./components/CookiePopup";
import Calendar from "./pages/Calendar";


const theme = createTheme();

const sections = [{title: 'Home', url: '/'}, {title: 'About', url: '/about'}, {
    title: 'Shop',
    url: 'https://shop.emblazonedindustries.com'
}, {title: 'Contact', url: '/contact'}, {title: 'Services', url: '/services'}, {
    title: 'Training and Education',
    url: '/training'
}, {title: 'Course Calendar', 'url': '/calendar'},
    {title: 'Membership', 'url': '/membership'}, {
        title: 'Consignment',
        'url': '/consignment'
    }, {title: 'Links and Resources', url: '/links'}];

export default function App() {
    return (
        <div className='App'>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <Container maxWidth="lg">
                    <main>
                        <Router>
                            <Routes>
                                <Route exact path='/' element={<Home sections={sections}/>}/>
                                <Route exact path='/home' element={<Home sections={sections}/>}/>
                                <Route exact path='/about' element={<About sections={sections}/>}/>
                                <Route exact path='/contact' element={<Contact sections={sections}/>}/>
                                <Route exact path='/links' element={<Links sections={sections}/>}/>
                                <Route exact path='/training' element={<Training sections={sections}/>}/>
                                <Route exact path='/services' element={<Services sections={sections}/>}/>
                                <Route exact path='/membership' element={<Membership sections={sections}/>}/>
                                <Route exact path='/consignment' element={<Consignment sections={sections}/>}/>
                                <Route exact path='/calendar' element={<Calendar sections={sections}/>}/>
                                <Route path='*' element={<Home sections={sections}/>}/>
                            </Routes>
                        </Router>
                    </main>
                    <Footer/>
                </Container>
            </ThemeProvider>
            <CookiePopup/>

        </div>
    );
}
